import React, { useState, useEffect } from 'react'
import { AxisBottom, AxisLeft } from '@vx/axis'

import { axisColor, tickSize, xLabelOffsetVX, yLabelOffsetVX } from './constants'
import { axisLabel, tickLabelX, tickLabelY } from './axes.style'

export const Axes = function ({
  chartRef,
  scales,
  labels,
  dimensions,
  formatters,
  tickValues = {},
  options = { hideAxisLeft: false },
  axisBottomProps = {},
  axisLeftProps = {}
}) {
  const { width, height } = dimensions
  const [numBottomTicks, setNumBottomTicks] = useState()

  // Detect text overlap with bottom axis tick marks and update
  // accordingly to mitigate this text overlapping
  useEffect(() => {
    if (chartRef && chartRef.current) {
      // Loop through bottom axis ticks and detect any overlapping text
      const axisBottomTicks = Array.from(chartRef.current.querySelectorAll('.vx-axis-bottom .vx-axis-tick'))
      let overlappedElementExists = axisBottomTicks.find((tick, i) => {
        const nextTick = axisBottomTicks[i + 1]
        if (tick && nextTick && tick.getBoundingClientRect().right > nextTick.getBoundingClientRect().left) {
          return true
        }
      })

      // If an overlapped element is found, update the number of ticks
      // to be fewer so that there is enough space for all ticks
      if (overlappedElementExists) {
        // Find max width tick
        const maxTickWidth = axisBottomTicks.reduce((width, tick) => {
          const tickWidth = tick.getBoundingClientRect().width
          if (tickWidth > width) {
            width = tickWidth
          }
          return width
        }, 0)

        // Use max tick width as a determining factor in the number of
        // ticks to set and set the number of ticks accordingly
        const TICK_SPACING = 6 // At least 6 pixels between each tick
        setNumBottomTicks(Math.floor(width / (maxTickWidth + TICK_SPACING) - 1))
      }
    }
  }, [chartRef && chartRef.current])

  return (
    <>
      <AxisBottom
        hideZero={false}
        label={labels.x}
        labelOffset={xLabelOffsetVX}
        labelProps={axisLabel}
        scale={scales.x}
        stroke={axisColor}
        tickFormat={formatters.x}
        tickLabelProps={() => tickLabelX}
        tickLength={tickSize}
        tickStroke={axisColor}
        tickValues={tickValues.x}
        top={height}
        numTicks={numBottomTicks}
        {...axisBottomProps}
      />
      {!options.hideAxisLeft &&
        <AxisLeft
          hideZero={false}
          label={labels.y}
          labelOffset={yLabelOffsetVX}
          labelProps={axisLabel}
          scale={scales.y}
          stroke={axisColor}
          tickFormat={formatters.y}
          tickLabelProps={() => tickLabelY}
          tickLength={tickSize}
          tickStroke={axisColor}
          tickValues={tickValues.y}
          {...axisLeftProps}
        />
      }
    </>
  )
}
